// `config` se importa directo y NO por el contenedor: `inversify-config` importa este modulo, asi
// que pedirselo cierra un ciclo. Es el mismo objeto en los dos casos, porque el contenedor lo
// registra con `toConstantValue(config)`.
import config from 'src/config/app-config';
import { QueryApiService } from 'src/common/api-service';
import { Testimony } from './types';

export class TestimonialsApiService extends QueryApiService<Testimony> {
  constructor() {
    super('Testimonials');
    const baseUrl = config.baseUrl;
    this._apiBaseUrl = `${baseUrl}/api/v1/Testimonials`;
    this._odataBaseUrl = `${baseUrl}/odata/v1/Testimonials`;
  }
}
